import { OrbitControls } from "@react-three/drei";
import { useXR } from "@react-three/xr";
import { useViewerPopupStore } from "../../../state management/zustand/viewer-stores";
import { useSceneStore } from "../../../api/Zustand";
import { useZoomStore } from "../../../state management/zustand/common-stores";

const Controls = () => {
  const { zoom } = useZoomStore();

  const { scene } = useSceneStore();

  const isPresenting = useXR((state) => {
    return state.isPresenting;
  });

  const popup = useViewerPopupStore();

  return (
    <OrbitControls
      makeDefault
      enabled={!popup.isOpen && !isPresenting}
      reverseOrbit
      enablePan={false}
      enableZoom={false}
      enableDamping={false}
      maxPolarAngle={scene?.lockRotation ? Math.PI / 2 : Math.PI}
      minPolarAngle={scene?.lockRotation ? Math.PI / 2 : 0}
      rotateSpeed={zoom * 0.003}
    />
  );
};

export default Controls;
